export const data = [
  {
    image:
      "https://res.cloudinary.com/madebyibukunoluwa/image/upload/v1667566756/portfolio-website/portfoliowebsite_majlpy.png",
    title: "PortFolio Website",
    summary: "My personal Front-end developer portfolio website",
    technologies: [
      "REACT",
      "Javascript",
      "Styled-Components",
      "CSS",
      "React-Router",
      "React-icons",
      "Cloudinary",
    ],
    id: Math.random() * 1000000,
    link: "",
  },

  {
    image:
      "https://res.cloudinary.com/madebyibukunoluwa/image/upload/v1667566698/portfolio-website/linktree_ytwkg8.png",
    title: "Link Tree Application",
    summary: "link tree like application ",
    technologies: [
      "REACT",
      "Javascript",
      "CSS",
      "React-Router",
      "MUI-components",
      "React-web-share",
    ],
    id: Math.random() * 1000000,
    link: "https://made-by-ibukunoluwa-link-tree-app.netlify.app/",
  },

  {
    image:
      "https://res.cloudinary.com/madebyibukunoluwa/image/upload/v1667566616/portfolio-website/ipaddresstracker_yzkv5q.png",
    title: "IP Address Tracker",
    summary: "Website that allows you to track IP addresses",
    technologies: [
      "REACT",
      "Javascript",
      "Styled-Components",
      "Axios",
      "leaflet", 
      "Ipgeolocation api",
      "React-icons",
      "MUI-components",
      
    ],
    id: Math.random() * 1000000,
    link: "#",
    status: "70% Done",
  },
  {
    image: "",
    title: "PiggyVest Clone",
    summary:
      "A clone of the piggyvest website landing page with the pages linked to it",
    technologies: [
      "REACT",
      "Javascript",
      "Styled-Components",
      "CSS",
      "React-Router",
    ],
    id: Math.random() * 1000000,
    link: "#",
  },
  {
    image: "",
    title: "Kanban Board",
    summary: "A kanban board made to visualise tasks",
    technologies: ["REACT", "Javascript", "Styled-Components", "CSS"],
    id: Math.random() * 1000000,
    link: "#",
  },
  {
    image: "",
    title: "Project 5",
    summary: "Project 5 is going to be here ",
    technologies: ["REACT", "Javascript", "Styled-Components", "CSS"],
    id: Math.random() * 1000000,
    link: "#",
  },
  {
    image: "",
    title: "Project 6",
    summary: "Project 6 is going to be here ",
    technologies: ["REACT", "Javascript", "Styled-Components", "CSS"],
    id: Math.random() * 1000000,
    link: "#",
  },
];
